export default "__VITE_ASSET__CY8Z6Mia__"